import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelpersService } from '../../services/helpers.service';

@Component({ standalone: false,
  selector: 'vfa-cp-dashboard-home-buttons',
  templateUrl: './dashboard-home-buttons.component.html',
  styleUrls: ['./dashboard-home-buttons.component.scss'],
})
export class DashboardHomeButtonsComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit() {}

  public navigateToAccount() {
    this.router.navigateByUrl("/dashboard/account");
  }

  public navigateToSupport() {
    this.router.navigateByUrl("/dashboard/support");
  }
}

